
import React from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const contactInfo = [
    {
      icon: 'ri-map-pin-line',
      title: 'Alamat Restoran',
      content: 'Jl. Raya Bukittinggi - Payakumbuh Jl. Raya Batusangkar No.km 6, Biaro Gadang, Kec. Ampek Angkek, Kabupaten Agam, Sumatera Barat 26152',
      color: 'red',
      action: () => window.open('https://maps.google.com/?q=Jl. Raya Bukittinggi - Payakumbuh Jl. Raya Batusangkar No.km 6, Biaro Gadang, Kec. Ampek Angkek, Kabupaten Agam, Sumatera Barat 26152', '_blank')
    },
    {
      icon: 'ri-whatsapp-line',
      title: 'WhatsApp',
      content: '0812-7543-743',
      color: 'green',
      action: () => window.open('https://wa.me/6281275437430?text=Halo TAKEYA Restaurant! Saya ingin mendapatkan informasi lebih lanjut.', '_blank')
    },
    {
      icon: 'ri-phone-line',
      title: 'Telepon',
      content: '0812-7543-743',
      color: 'blue',
      action: () => window.open('tel:+6281275437430', '_blank')
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      content: 'info@takeya-restaurant.com',
      color: 'yellow',
      action: () => window.open('mailto:info@takeya-restaurant.com', '_blank')
    },
    {
      icon: 'ri-time-line',
      title: 'Jam Operasional',
      content: 'Senin - Kamis: 10:00 - 22:00 WIB\nJumat - Minggu: 10:00 - 23:00 WIB',
      color: 'purple',
      action: null
    },
    {
      icon: 'ri-service-line',
      title: 'Layanan',
      content: 'Dine In • Take Away • Delivery • Catering • Private Event',
      color: 'orange',
      action: null
    }
  ];

  const socialMedia = [
    { icon: 'ri-instagram-line', name: 'Instagram', url: 'https://instagram.com/takeya_restaurant', color: 'from-pink-500 to-red-500' },
    { icon: 'ri-facebook-line', name: 'Facebook', url: 'https://facebook.com/takeya.restaurant', color: 'from-blue-500 to-blue-600' },
    { icon: 'ri-tiktok-line', name: 'TikTok', url: 'https://tiktok.com/@takeya_restaurant', color: 'from-gray-800 to-gray-900' },
    { icon: 'ri-youtube-line', name: 'YouTube', url: 'https://youtube.com/@takeya_restaurant', color: 'from-red-500 to-red-600' }
  ];

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-gray-900 to-black dark:from-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-white mb-6" style={{ fontFamily: '"Noto Sans JP", serif' }}>
            Hubungi <span className="text-red-500">Kami</span>
            <span className="block text-3xl text-yellow-400 mt-2">お問い合わせ</span>
          </h2>
          <div className="flex items-center justify-center space-x-4 mb-8">
            <div className="h-px w-20 bg-gradient-to-r from-transparent to-red-500"></div>
            <div className="text-yellow-400 text-lg font-bold" style={{ fontFamily: '"Orbitron", sans-serif' }}>
              GET IN TOUCH
            </div>
            <div className="h-px w-20 bg-gradient-to-l from-transparent to-red-500"></div>
          </div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Hubungi kami untuk reservasi, informasi menu, atau pertanyaan lainnya. Tim kami siap melayani Anda dengan sepenuh hati
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12 mb-16">
          {/* Contact Information Cards */}
          <div className="lg:col-span-2">
            <div className="grid md:grid-cols-2 gap-6">
              {contactInfo.map((info, index) => (
                <div
                  key={index}
                  className={`bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 p-6 hover:border-red-500/40 transition-all duration-300 group ${info.action ? 'cursor-pointer' : ''}`}
                  onClick={info.action || undefined}
                >
                  <div className="flex items-start space-x-4">
                    <div className={`w-14 h-14 bg-gradient-to-br ${
                      info.color === 'red' ? 'from-red-500 to-red-600' :
                      info.color === 'green' ? 'from-green-500 to-green-600' :
                      info.color === 'blue' ? 'from-blue-500 to-blue-600' :
                      info.color === 'yellow' ? 'from-yellow-500 to-yellow-600' :
                      info.color === 'purple' ? 'from-purple-500 to-purple-600' :
                      'from-orange-500 to-orange-600'
                    } rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${info.icon} text-white text-xl w-7 h-7 flex items-center justify-center`}></i>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-white font-bold text-lg mb-2 group-hover:text-red-400 transition-colors">{info.title}</h3>
                      <p className="text-gray-300 text-sm leading-relaxed whitespace-pre-line">{info.content}</p>
                      {info.action && (
                        <div className="mt-3">
                          <span className="text-red-400 text-sm font-semibold group-hover:text-red-300 transition-colors">
                            Klik untuk {info.title.toLowerCase()} →
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Social Media & Quick Actions */}
          <div className="space-y-8">
            {/* Social Media */}
            <div className="bg-gradient-to-br from-red-900/20 to-yellow-900/20 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">Follow Us</h3>
              <div className="grid grid-cols-2 gap-4">
                {socialMedia.map((social, index) => (
                  <button
                    key={index}
                    onClick={() => window.open(social.url, '_blank')}
                    className={`bg-gradient-to-br ${social.color} p-4 rounded-2xl text-white font-semibold text-center hover:scale-105 transition-transform duration-300 cursor-pointer`}
                  >
                    <i className={`${social.icon} text-2xl mb-2 w-8 h-8 flex items-center justify-center mx-auto`}></i>
                    <span className="text-sm">{social.name}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 p-8">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">Quick Actions</h3>
              <div className="space-y-4">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => window.open('https://wa.me/628127543743?text=Halo TAKEYA! Saya ingin melakukan reservasi meja.', '_blank')}
                  className="w-full whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                  Reservasi via WhatsApp
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  onClick={() => window.open('https://wa.me/628127543743?text=Halo TAKEYA! Saya ingin melihat menu dan harga terbaru.', '_blank')}
                  className="w-full whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-restaurant-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                  Tanya Menu & Harga
                </Button>
                <Button
                  variant="secondary"
                  size="lg"
                  onClick={() => window.open('https://wa.me/628127543743?text=Halo TAKEYA! Saya ingin informasi untuk catering event.', '_blank')}
                  className="w-full whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-service-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                  Catering & Event
                </Button>
              </div>
            </div>

            {/* Emergency Contact */}
            <div className="bg-gradient-to-br from-red-900/30 to-red-800/30 backdrop-blur-sm rounded-3xl border border-red-500/30 p-6">
              <div className="text-center">
                <i className="ri-customer-service-line text-red-400 text-3xl mb-3 w-10 h-10 flex items-center justify-center mx-auto"></i>
                <h4 className="text-white font-bold mb-2">Layanan 24/7</h4>
                <p className="text-gray-300 text-sm mb-4">
                  Untuk reservasi mendesak atau pertanyaan darurat
                </p>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => window.open('tel:+628127543743', '_blank')}
                  className="whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                  Hubungi Sekarang
                </Button>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-3xl border border-red-500/20 overflow-hidden">
          <div className="p-8 border-b border-red-500/20">
            <h3 className="text-2xl font-bold text-white mb-4 text-center">Lokasi TAKEYA Restaurant</h3>
            <p className="text-gray-300 text-center max-w-2xl mx-auto">
              Terletak strategis di jalur utama Bukittinggi - Payakumbuh, mudah diakses dengan kendaraan pribadi maupun transportasi umum
            </p>
          </div>
          <div className="h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.8234567890!2d100.31635825000001!3d-0.30394999999999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2fd538c3ca9fbc5b%3A0x4d1f9c7c5e8a3c2e!2sJl.%20Raya%20Bukittinggi%20-%20Payakumbuh%2C%20Biaro%20Gadang%2C%20Kec.%20Ampek%20Angkek%2C%20Kabupaten%20Agam%2C%20Sumatera%20Barat!5e0!3m2!1sen!2sid!4v1632147892345!5m2!1sen!2sid"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Lokasi TAKEYA Restaurant"
            ></iframe>
          </div>
        </div>

        {/* Business Hours Detail */}
        <div className="mt-12 grid md:grid-cols-3 gap-8">
          <div className="bg-gradient-to-br from-green-900/20 to-green-800/20 backdrop-blur-sm rounded-3xl border border-green-500/20 p-8 text-center">
            <i className="ri-time-line text-green-400 text-4xl mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
            <h4 className="text-white font-bold text-xl mb-3">Jam Operasional</h4>
            <div className="space-y-2 text-gray-300">
              <p><strong className="text-green-400">Sen - Kam:</strong> 10:00 - 22:00</p>
              <p><strong className="text-green-400">Jum - Min:</strong> 10:00 - 23:00</p>
              <p className="text-red-400 text-sm mt-3">*Tutup pada hari libur nasional</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-blue-900/20 to-blue-800/20 backdrop-blur-sm rounded-3xl border border-blue-500/20 p-8 text-center">
            <i className="ri-truck-line text-blue-400 text-4xl mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
            <h4 className="text-white font-bold text-xl mb-3">Delivery Area</h4>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>• Bukittinggi City</p>
              <p>• Payakumbuh</p>
              <p>• Batusangkar</p>
              <p>• Sekitar radius 15km</p>
              <p className="text-blue-400 mt-3">Min. order Rp 100.000</p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-purple-900/20 to-purple-800/20 backdrop-blur-sm rounded-3xl border border-purple-500/20 p-8 text-center">
            <i className="ri-parking-line text-purple-400 text-4xl mb-4 w-12 h-12 flex items-center justify-center mx-auto"></i>
            <h4 className="text-white font-bold text-xl mb-3">Fasilitas</h4>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>• Parkir Luas & Gratis</p>
              <p>• WiFi High Speed</p>
              <p>• AC & Music System</p>
              <p>• Private VIP Room</p>
              <p className="text-purple-400 mt-3">• Musholla & Kids Area</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
